<template>
  <div v-if="store" class="min-h-screen">
    <div class="relative">
      <StoresSlider :store="store" />
    </div>

    <StoresMetaTile :store="store" :view-all-info="true" />
    <div v-if="store?.location?.lat && store?.location?.lng" class="w-full p-3">
      <client-only>
        <GoogleMap
          ref="placeMap"
          :api-key="useMapKey()"
          :center="store?.location"
          class="rounded-lg"
          :zoom="12"
          :street-view-control="false"
          :map-type-control="false"
          :fullscreen-control="true"
          :clickable-icons="false"
          :gesture-handling="'none'"
          :scrollwheel="false"
          style="width: 100%; height: 200px; margin: auto"
        >
          <Marker
            :options="{
              position: store?.location,
              draggable: false,
              clickable: false
            }"
          />
        </GoogleMap>
      </client-only>
    </div>
  </div>
</template>

<script setup lang="ts">
import { GoogleMap, Marker } from 'vue3-google-map'
const { url } = useDomainHost()
const { store } = useDomainState()

const { t } = useI18n()

useServerSeoMeta(
  useOgMeta(url + '/address', t('address'), store.value?.about, store.value?.thumb)
)

useHead({
  title: t('address'),
  meta: [
    { hid: 'description', name: 'description', content: store.value?.about }
  ],
  link: [useSeoCanonical(url + '/address')],
  script: [
    useSeoBreadcrumb([
      useSeoBreadcrumbItem(1, store.value?.name, url),
      useSeoBreadcrumbItem(2, t('address'), url + '/address')
    ])
  ]
})
</script>
